import { ModalProps } from 'rsuite/lib/Modal';
import { ActionFeedbackDialog } from '../../../../../../../../components';

export type ProcessandoArquivoModalProps = ModalProps & {
  onHide?: () => void;
};

export const ProcessandoArquivoModal = ({ show, onHide }: ProcessandoArquivoModalProps) => {
  return (
    <ActionFeedbackDialog
      open={Boolean(show)}
      type="success"
      title="Estamos processando o arquivo"
      description={
        <>
          Seu arquivo está sendo validado e pode levar até 30 minutos.
          <br />
          Avisaremos por e-mail quando a negociação estiver pronta.
        </>
      }
      onClose={onHide}
      primaryAction={{
        label: 'FECHAR',
        onClick: () => onHide?.(),
      }}
    />
  );
};
